<template>
  <ProSpaceRightPanel
    v-if="ids.length > 0"
    :header="header"
    :loading="loading"
    :has-error="hasError"
    @clear="clearPanel"
    @edit="editPanel"
    @delete="deletePanel"
    @show-history="showHistoryPanel"
  >
    <template v-if="ids.length === 1" v-slot:center>
      <ProSpacePanelBlock :header="headerKAEs">
        <template #header>
          <ProSpaceAction :text="$t('editItemTxt')" @click="editPanel" />
        </template>
        <ProSpacePanelBlockList :list="content" />
      </ProSpacePanelBlock>
    </template>
    <template v-if="ids.length === 1" v-slot:bottom>
      <ProSpacePanelBlock :header="headerBottom">
        <template v-slot>
          <ProSpacePanelBlockList :list="contentBottom" />
        </template>
      </ProSpacePanelBlock>
    </template>
  </ProSpaceRightPanel>
</template>

<script>
import {
  ProSpaceRightPanel,
  ProSpaceTabs,
  ProSpacePanelBlock,
  ProSpacePanelBlockList,
  ProSpaceAction,
} from "@prospace/prospace-components-library";
import { KAEService } from "../../../services/KAEService";
import { mapGetters } from "vuex";
import {getAMorPM} from "@prospace/prospace-components-library/src/lib-assets/mixins/date";
export default {
  name: "KAEPanel",
  components: {
    ProSpaceRightPanel,
    ProSpaceTabs,
    ProSpacePanelBlock,
    ProSpacePanelBlockList,
    ProSpaceAction,
  },
  props: {
    options: {
      type: Array,
      default: () => {
        return [];
      },
    },
    ids: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      kAE: null,
      kAEService: new KAEService(),
      loading: false,
      hasError: false,
    };
  },
  computed: {
    ...mapGetters({
      userinfo: "userinfoStore/getUserinfo",
      getFormatDateTime: "userinfoStore/getFormatDateTime"
    }),
    headerKAEs() {
      return {
        title: this.$t("overview"),
        isExpand: false,
      };
    },
    headerBottom() {
      return {
        title: this.$t("metaInfTxt"),
        isExpand: true,
      };
    },
    tabs() {
      return [{ name: this.$t("overview"), isActive: true }];
    },
    header() {
      if (this.kAE) {
        return {
          title: this.kAE.value,
          id: this.ids[0],
          status: this.getStatus(this.kAE.status),
          options: this.options,
          showCounter: false,
        };
      }
      return {
        title: this.$t("itemsSelected"),
        counter: this.ids.length,
        showCounter: true,
        cleareble: true,
      };
    },
    content() {
      if (this.kAE) {
        return [
          [
            {
              title: this.$t("code"),
              text: this.kAE.code,
            },
          ],
          [
            {
              title: this.$t("kAEValue"),
              text: this.kAE.value,
            },
          ],
        ];
      }
      return [];
    },
    contentBottom() {
      if (this.kAE) {
        return [
          [
            {
              title: this.$t("createdByTxt"),
              text: this.kAE.createdBy,
            },
            {
              title: this.$t("updatedByTxt"),
              text: this.kAE.updatedBy,
            },
          ],
          [
            {
              title: this.$t("createdAtTxt"),
              text: this.getFormatDateTime(this.kAE.createdAt) + ' ' + getAMorPM(this.kAE.createdAt, this.userinfo?.timeFormat),
            },
            {
              title: this.$t("lastUpdatedTxt"),
              text: this.getFormatDateTime(this.kAE.lastUpdated) + ' ' + getAMorPM(this.kAE.lastUpdated, this.userinfo?.timeFormat),
            },
          ],
        ];
      }
      return [];
    },
  },
  mounted() {
    this.update();
  },
  watch: {
    ids() {
      this.update();
    },
  },
  methods: {
    update() {
      this.hasError = false;
      try {
        this.getKAE();
      } catch (e) {
        this.hasError = true;
      }
    },
    getKAE() {
      if (this.ids.length === 1) {
        this.loading = true;
        this.kAEService.get(this.ids[0]).then((res) => {
          this.kAE = res.data;
          this.loading = false;
        });
      }
      this.kAE = null;
    },
    getStatus(status) {
      if (!status) return;
      return {
        type: status === "ACTIVE" ? "success" : "danger",
        text: status[0].toUpperCase() + status.toLowerCase().slice(1),
      };
    },
    clearPanel() {
      this.$emit("clear");
    },
    editPanel() {
      this.$emit("edit", this.kAE);
    },
    deletePanel() {
      this.$emit("delete", this.kAE);
    },
    showHistoryPanel() {
      this.$emit("history", this.kAE);
    },
  },
};
</script>

<style scoped></style>
